export const BANNER_LIST_ACTION = "BANNER_LIST_ACTION";
export const BANNER_LIST_SUCCESS = "BANNER_LIST_SUCCESS";
export const BANNER_UPDATE_ACTION = "BANNER_UPDATE_ACTION";
export const BANNER_UPDATE_SUCCESS = "BANNER_UPDATE_SUCCESS";
export const BANNER_INIT = "BANNER_INIT";
export const BANNER_FAILED = "BANNER_FAILED";
